import { BOGeneralValues } from "./BOGeneralValues.model";

export class BODeathMedicDiagnostic extends BOGeneralValues{
    id:number;
    diseaseCode:string;
    orphanDisease:string;
    diseaseName:string;
}